module.exports = __webpack_public_path__ + "static/media/music-alt-slash.354989a4.svg";